export const API_URL =
  process.env.REACT_APP_API_URL ?? 'http://localhost:3000/api/v1';
export const USER_TOKEN_STORAGE_KEY = 'user_token';

export const USER_STORAGE = 'user';

export const API_SEARCH_BY_ADDRESS_KEY =
  process.env.REACT_APP_API_SEARCH_BY_ADDRESS_KEY ?? '';
